import React, {useState, useEffect} from 'react';
import styles from './Header.module.scss';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import {motion,} from "framer-motion";
import logo from "../../assets/images/logo.png";
import sns_medi from "../../assets/images/icon/sns_medi.svg";
import sns_twit from "../../assets/images/icon/sns_twit.svg";
import sns_tele from "../../assets/images/icon/sns_tele.svg";
import translate_earth from "../../assets/images/icon/translate_earth.svg";
import {useTranslation} from 'react-i18next'

const Header = () => {
    const {i18n} = useTranslation();
    const [languageBox, setLanguageBox] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
    const toggleLanguageBox = () => {
        const boxStatus = languageBox === true ? false : true;
        setLanguageBox(boxStatus);
    };
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        setCurrentLanguage(lang)
    }
    const [scrollPosition, setScrollPosition] = useState(0);
    const updateScroll = () => {
        setScrollPosition(window.scrollY || document.documentElement.scrollTop);
    }
    useEffect(() => {
        window.addEventListener('scroll', updateScroll);
    });

    const [showHeader, setShowHeader] = useState(true);

    useEffect(() => {
        let prevScrollPos = window.pageYOffset;
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            setShowHeader(prevScrollPos > currentScrollPos);
            prevScrollPos = currentScrollPos;
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <div className={`${(showHeader) ? `opacity-100` : `opacity-0`} ${styles.Header} px-5`}>
            <Navbar collapseOnSelect expand="lg" variant="dark" className={`${(scrollPosition < 100) ? styles.org_header : styles.change_header} justify-content-between d-flex w-100 fixed-top`}>
                <Container>
                    <Navbar.Brand href="#home">
                        <img src={logo} alt={`logo`}/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className={`${styles.nav_link} m-auto`}>
                            <Nav.Link href="#About">Home</Nav.Link>
                            <Nav.Link href="https://ontel-foundation-ltd.gitbook.io/ontel/" target={`_blank`}>Whitepaper</Nav.Link>
                            <Nav.Link href="https://app.ontellabs.com/">Market</Nav.Link>
                            <Nav.Link href="javascript:alert('준비중입니다.')">Swap</Nav.Link>
                            <Nav.Link href="#Roadmap">Roadmap</Nav.Link>
                        </Nav>
                        <div className={styles.sns_box}>
                            <a href={`https://t.me/ONTELoffical`} target={`_blank`}>
                                <img src={sns_tele}/>
                            </a>
                            <a href={`https://medium.com/@ONTELofficial`} target={`_blank`}>
                                <img src={sns_medi}/></a>
                            <a href={`https://twitter.com/ONTELofficial`} target={`_blank`}>
                                <img src={sns_twit}/></a>
                            <a>
                                <img src={translate_earth} onClick={toggleLanguageBox} style={{cursor: 'pointer'}}/></a>
                            {languageBox &&
                                <div className={styles.language_box}>
                                    <button onClick={()=>{changeLanguage('ko-KR')}} className={`${(currentLanguage === 'ko-KR') ? styles.lang_active : ``}`}>KO</button><br/>
                                    <button onClick={()=>{changeLanguage('en-US')}} className={`${(currentLanguage === 'en-US') ? styles.lang_active : ``}`}>EN</button>
                                </div>
                            }

                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
}

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
